import { PayloadAction } from '@reduxjs/toolkit';
import {
  IBankDetailsBase,
  IContactDetails,
  IEmployee,
  IEmployeeInitial,
  IPersonalDetails,
  IPrivateEntrepreneurDetailsBase,
} from './employee.types';

export const actions = {
  setCurrentPage(state: IEmployeeInitial, { payload }: PayloadAction<number>) {
    state.currentPage = payload;
  },
  setFilters(state: IEmployeeInitial, { payload }: PayloadAction<{ search?: string; status?: string }>) {
    state.filters = {
      ...state.filters,
      ...payload,
    };
  },
  setCurrentEmployee(state: IEmployeeInitial, { payload }: PayloadAction<IEmployee>) {
    state.currentEmployee = {
      ...payload,
    };
  },
  updatePersonalDetails(state: IEmployeeInitial, { payload }: PayloadAction<IPersonalDetails>) {
    state.currentEmployee.personalInformation = payload;
  },
  updateContactDetails(state: IEmployeeInitial, { payload }: PayloadAction<IContactDetails>) {
    state.currentEmployee.contact = {
      ...payload,
      phoneNumber: {
        code: payload.phoneNumber.code,
        phone: payload.phoneNumber.phone,
      },
    };
  },
  updateBankDetails(state: IEmployeeInitial, { payload }: PayloadAction<IBankDetailsBase>) {
    state.currentEmployee.bankDetails = {
      ...payload,
    };
  },
  updateEntrepreneurDetails(state: IEmployeeInitial, { payload }: PayloadAction<IPrivateEntrepreneurDetailsBase>) {
    state.currentEmployee.privateEntrepreneurInformation = {
      ...payload,
    };
  },
};
